
import { Component, Mixins } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { User } from "../../../../domain/user";
import { Department } from "../../../../domain/department";
import { ModalPresentableMixin } from "../../../system/mixins";
import { DepartmentFeatureAccessibleMixin } from "../../../department/mixins";

@Component
export default class AccountViewerMixin extends Mixins(ModalPresentableMixin, DepartmentFeatureAccessibleMixin) {
  get isLogoutEnable(): boolean {
    return this.$configuration.behavior.authentication.logout.isEnable;
  }

  get isAuthorized(): boolean {
    return this.$store.getters.isAuthorized;
  }

  get isLoading(): boolean {
    return this.isAuthorized && !this.user;
  }

  get user(): User {
    return this.$store.getters.user;
  }

  get userName(): string {
    return this.user
      ? this.user.name
      : "";
  }

  get department(): Department {
    return this.$store.getters.department;
  }

  set department(value: Department) {
    this.$store.commit("setDepartment", value);
  }

  get departmentName(): string {
    return this.department
      ? this.department.name
      : "";
  }

  get orderUser(): User {
    return this.$store.getters.orderUser;
  }

  get orderUserName(): string {
    return this.orderUser
      ? this.orderUser.name
      : null;
  }

  get orderUserDescription(): string {
    return this.orderUser
      ? "指示:" + this.orderUserName
      : "";
  }

  get attendingUser(): User {
    return this.$store.getters.attendingUser;
  }

  get attendingUserName(): string {
    return this.attendingUser
      ? this.attendingUser.name
      : null;
  }

  get attendingUserDescription(): string {
    return this.attendingUser
      ? "指導:" + this.attendingUserName
      : "";
  }

  get accountDescription(): string {
    const description = this.isDepartmentFeatureEnable
      ? this.userName + "@" + this.departmentName
      : this.userName;
    const extraUserDescriptions = [this.orderUserDescription, this.attendingUserDescription].filter(d => !!d);
    const extraUserJoinedDescription = (extraUserDescriptions.length !== 0)
      ? "(" + extraUserDescriptions.join("/") + ")"
      : "";
    return description + extraUserJoinedDescription;
  }
  
  selectDepartment(): void {
    const condition = {
      name: "ログイン" + this.$wording.common.department,
      isUserDepartmentsOnly: true,
    };
    this.$commonDialogs.department.buttonSelector.selectOptionConditionally(condition, this.department)
      .then(d => {
        if (d !== undefined) {  // undefinedの時はキャンセル.
          this.department = d;
        }
        if (d) {
          DomainRegistry.department.getDepartmentRepository().saveSelectedDepartment(this.$store.getters.user.id, d.id);
        }
      })
      .catch(e => {
        this.$error(
          "ログイン" + this.$wording.common.department + "選択失敗",
          "ログイン" + this.$wording.common.department + "選択中にエラーが発生しました。",
          e,
        );
      });
  }

  async logout(): Promise<void> {
    try {
      const service = DomainRegistry.authentication.getAuthenticationService();
      await service.logout();
    } catch (e) {
      // ログアウト中にエラー発生しても
      console.error("ログアウト中にエラーが発生しました.無視してログアウト継続します.");
      console.error(e);
    }
    this.$success(
      "ログアウト完了",
      "ログアウトしました。",
      () => this.$router.replace({
        path: "/Login", // メニュー(ルート)に飛ばすつもりだったが、メニューでログアウトすると、同一ルートなのでフックが効かず、ログイン画面へ遷移しない.直接ログインが画面へ.
      })
    );
  }
}
